module.exports = __webpack_public_path__ + "img/about-org.9bdabc0c.png";